import {Component, inject, OnInit, Pipe, PipeTransform} from '@angular/core';
import {
  IonAccordion,
  IonAccordionGroup,
  IonCol,
  IonItem,
  IonSegment,
  IonSegmentButton
} from "@ionic/angular/standalone";
import {FormsModule} from '@angular/forms';
import {FaqService} from './faq.service';
import {LanguageService} from '../../../core/language.service';

@Pipe({
  name: 'faqFilter',
})
export class FaqFilter implements PipeTransform {
  transform(value: any, arg: string): any {
    if (arg) {
      return value.filter((item: any) => item.type === arg);
    } else {
      return value;
    }
  }

}

@Component({
    selector: 'app-faq',
  template: `

    <ion-segment value="generic" [(ngModel)]="faqToggle">
      <ion-segment-button value="generic">Generic</ion-segment-button>
      <ion-segment-button value="tenants">Tenants</ion-segment-button>
      <ion-segment-button value="landlords">Landlords</ion-segment-button>
    </ion-segment>
    <ion-accordion-group>
      @for (faq of faqService.faqData | faqFilter: faqToggle; track faq._id;) {
        <ion-accordion [toggleIcon]="toggleIcon">
          <ion-item slot="header" [dir]="languageService.dir()">{{ languageService.lang() === 'en' ? faq.titleEn : faq.titleAr }}</ion-item>
          <div class="accordion-content" slot="content" [dir]="languageService.dir()">
            <p>{{ languageService.lang() === 'en' ? faq.descriptionEn : faq.descriptionAr}}</p>
          </div>
        </ion-accordion>
      }
    </ion-accordion-group>

  `,
  styles: `
    $mobile-width: 768px;
    ion-segment {
      margin-bottom: 1.5rem;
      height: 40px;
    }
    ion-segment-button {
      --border-color: transparent;
    }
    ion-accordion {
      ion-item {
        --min-height: 56px;
      }
      .accordion-content {
        padding: 16px;
        line-height: 1.4;
      }
      p {
        line-height: 1.4;
      }
    }
    .faq-wrapper {
      padding: 3rem 24px;
      ion-button {
        margin-top: 1.5rem;
      }
      .h2 {
        font-size: 2rem;
        font-weight: 600;
        line-height: 1.4;
        margin-bottom: 1.25rem;
      }
      p {
        line-height: 1.4;
      }
    }

    @media screen and (max-width: $mobile-width) {
      ion-accordion-group,
      ion-segment {
        margin-top: 1.5rem;
      }
    }

  `,
  imports: [
    IonAccordion,
    IonAccordionGroup,
    IonItem,
    IonSegment,
    IonSegmentButton,
    FormsModule,
    FaqFilter
  ]
})
export class FaqComponent  implements OnInit {

  faqToggle: string = 'generic';
  toggleIcon: string = 'add';
  faqService: FaqService = inject(FaqService);
  languageService: LanguageService = inject(LanguageService);
  constructor() { }

  ngOnInit() {}

}
